/* Cheriemood: galeri, paket secimi, teslim tarihi, canli LED onizleme, kar, isik dizisi cubugu */
(function () {
  var d = document;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // galeri: slaytlar ust uste hazir, gecis aninda. Ana gorsel tiklaninca lightbox.
  var gal = d.querySelector('[data-gal]'), main = gal && gal.querySelector('.gal__main');
  var slides = gal ? [].slice.call(gal.querySelectorAll('.gal__slide')) : [];
  var thumbs = gal ? [].slice.call(gal.querySelectorAll('.gal__thumbs button')) : [];
  var cur = Math.max(0, slides.findIndex(function (x) { return x.classList.contains('is-on'); }));
  var show = function (i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (x, j) { x.classList.toggle('is-on', j === cur); });
    thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
    var tb = thumbs[cur], wrap = tb && tb.parentNode;   // tek satir serit: aktif kucuk resmi gorunur tut
    if (tb && wrap) { var l = tb.offsetLeft - (wrap.clientWidth - tb.offsetWidth) / 2; wrap.scrollTo({ left: Math.max(0, l), behavior: 'smooth' }); }
  };
  thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
  show(cur);

  // lightbox: kaydirarak (swipe / scroll-snap), oklar, klavye
  // 2026-10-25: kare sayfadaki hazir halle aninda acilir (eskiden 21 kare bastan 2000 px iniyordu, telefonda ~1 sn bekletiyordu);
  // ekran daha keskin isterse yalniz bakilan kare ve iki komsusu arkadan iner, inince yer degistirir. Buyuk kare gelmezse kucugu kalir.
  // Oklar ve klavye 0,2 sn'de gecer (tarayicinin yumusak kaydirmasi ~1 sn suruyordu).
  var lb, track, count, cap, lbImgs = [], pos = 0, moving = false, anim = 0;
  var icon = function (dp) { return '<svg viewBox="0 0 20 20" fill="none"><path d="' + dp + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
  var sharp = function (i) {
    var need = Math.min(track.clientWidth, track.clientHeight) * (window.devicePixelRatio || 1);
    [i, i + 1, i - 1].forEach(function (j) {
      var im = lbImgs[j], full = slides[j] && slides[j].dataset.full;
      if (!im || im._hd || !full || im.src === full) return;
      var have = im.naturalWidth || +((im.src.match(/[?&]width=(\d+)/) || [])[1] || 0);
      if (have >= need) return;
      im._hd = true;
      var hd = new Image(); hd._hd = true; hd.alt = im.alt; hd.src = full;
      (hd.decode ? hd.decode() : new Promise(function (ok, no) { hd.onload = ok; hd.onerror = no; }))
        .then(function () { if (im.parentNode) { im.parentNode.replaceChild(hd, im); lbImgs[j] = hd; } })
        .catch(function () {});
    });
  };
  var buildLb = function () {
    lb = d.createElement('div'); lb.className = 'lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Image viewer');
    lb.innerHTML = '<div class="lb__track"></div><div class="lb__bar"><span class="lb__count"></span><button class="lb__btn lb__close" type="button" aria-label="Close">' + icon('M5 5l10 10M15 5L5 15') + '</button></div>' +
      '<button class="lb__btn lb__nav lb__prev" type="button" aria-label="Previous image">' + icon('M12 4l-6 6 6 6') + '</button>' +
      '<button class="lb__btn lb__nav lb__next" type="button" aria-label="Next image">' + icon('M8 4l6 6-6 6') + '</button><p class="lb__cap"></p>';
    track = lb.querySelector('.lb__track'); count = lb.querySelector('.lb__count'); cap = lb.querySelector('.lb__cap');
    slides.forEach(function (x) {
      var s = d.createElement('div'); s.className = 'lb__slide';
      var im = d.createElement('img'); im.src = x.currentSrc || x.src; im.alt = x.alt; im.decoding = 'async';
      im.onerror = function () { im.onerror = null; if (x.dataset.full && im.src !== x.dataset.full) im.src = x.dataset.full; };
      s.appendChild(im); track.appendChild(s); lbImgs.push(im);
    });
    var at = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var label = function () {
      if (!moving) { pos = at(); sharp(pos); }
      count.textContent = (pos + 1) + ' / ' + slides.length; cap.textContent = slides[pos] ? slides[pos].alt : '';
    };
    var go = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i)); pos = i; sharp(i);
      var from = track.scrollLeft, to = i * track.clientWidth, id = ++anim, t0 = 0;
      if (RM || Math.abs(to - from) < 2) { track.scrollLeft = to; label(); return; }
      moving = true; track.style.scrollSnapType = 'none';
      // once kareye oturtmayi ac, sonra hedefe koy: tersi olunca tarayici eski kareye geri oturtuyordu (yeniden oturtma kurali)
      var end = function () { if (id !== anim) return; anim++; moving = false; track.style.scrollSnapType = ''; track.scrollLeft = to; label(); };
      var step = function (ts) {
        if (id !== anim) return;
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / 200);
        track.scrollLeft = from + (to - from) * (1 - Math.pow(1 - p, 3));
        if (p < 1) window.requestAnimationFrame(step); else end();
      };
      window.requestAnimationFrame(step);
      setTimeout(end, 260);   // kare cizimi durursa (arka plandaki pencere) yine yerine otursun
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(label); }, { passive: true });
    lb.querySelector('.lb__prev').addEventListener('click', function () { go(pos - 1); });
    lb.querySelector('.lb__next').addEventListener('click', function () { go(pos + 1); });
    lb.querySelector('.lb__close').addEventListener('click', closeLb);
    track.addEventListener('click', function (ev) { if (ev.target === track || ev.target.classList.contains('lb__slide')) closeLb(); });
    d.addEventListener('keydown', function (ev) {
      if (!lb.classList.contains('is-open')) return;
      if (ev.key === 'Escape') closeLb();
      if (ev.key === 'ArrowRight') go(pos + 1);
      if (ev.key === 'ArrowLeft') go(pos - 1);
    });
    lb._label = label;
    d.body.appendChild(lb);
  };
  var closeLb = function () {
    anim++; moving = false; track.style.scrollSnapType = '';
    lb.classList.remove('is-open'); d.body.classList.remove('lb-lock');
    show(pos); if (main) main.focus();
  };
  var openLb = function () {
    if (!slides.length) return;
    if (!lb) buildLb();
    lb.classList.add('is-open'); d.body.classList.add('lb-lock');
    track.scrollTo({ left: cur * track.clientWidth, behavior: 'auto' }); pos = cur; lb._label();
    lb.querySelector('.lb__close').focus();
  };
  var swiped = false;
  if (main) {
    main.querySelectorAll('[data-gnav]').forEach(function (b) { b.addEventListener('click', function (ev) { ev.stopPropagation(); show(cur + (+b.dataset.gnav)); }); });
    var tx = null, ty = null;
    main.addEventListener('touchstart', function (ev) { tx = ev.touches[0].clientX; ty = ev.touches[0].clientY; swiped = false; }, { passive: true });
    main.addEventListener('touchend', function (ev) {
      if (tx === null) return; var dx = ev.changedTouches[0].clientX - tx, dy = ev.changedTouches[0].clientY - ty; tx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; show(cur + (dx < 0 ? 1 : -1)); }
    }, { passive: true });
    main.addEventListener('click', function () { if (swiped) { swiped = false; return; } openLb(); });
    main.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); openLb(); } });
  }

  // para birimi: ziyaretcinin para birimi <body data-cur data-sym>'den, Liquid money_with_currency gibi "$129.00 USD"
  var ccy = d.body.getAttribute('data-cur') || 'USD', sym = d.body.getAttribute('data-sym') || '$';
  // ondalik ayraci Liquid'in bastigi fiyattan ("€58,95 EUR" virgul, "$64.99 USD" nokta)
  var lp0 = d.querySelector('[data-live-price]'), comma = !!lp0 && /\d,\d{2}(?!\d)/.test(lp0.textContent);
  var fmt = function (c) {
    var t = (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (comma) t = t.replace(/[,.]/g, function (m) { return m === ',' ? '.' : ','; });
    return sym + t + ' ' + ccy;
  };

  // boy + paket secimi (cm-size, cm-pack): [data-vmap] varyant listesinden id'yi ve fiyatlari bulur.
  // Eski duzen (name=id radyolari, sade urun sayfasi) de calisir.
  var form = d.querySelector('.cm-form');
  var q = function (sel) { return form ? [].slice.call(form.querySelectorAll(sel)) : []; };
  var vmapEl = form && form.querySelector('[data-vmap]'), vmap = [];
  try { vmap = vmapEl ? JSON.parse(vmapEl.textContent) : []; } catch (err) { vmap = []; }
  var sizeR = q('input[name=cm-size]'), packR = q('input[name=cm-pack]'), idR = q('input[type=radio][name=id]');
  var vidEl = form && form.querySelector('[data-vid]'), buyBtn = form && form.querySelector('[data-sbar-anchor]');
  var val = function (rs) { var c = rs.filter(function (r) { return r.checked; })[0]; return c ? c.value : null; };
  var find = function (s, p) { return vmap.filter(function (v) { return v.s === s && v.p === p; })[0]; };
  var live = function (c) { var t = fmt(c); d.querySelectorAll('[data-live-price]').forEach(function (x) { x.textContent = t; }); };
  var packUpd = function () {
    if (vmap.length && sizeR.length) {
      var s = val(sizeR), one = find(s, packR[0] && packR[0].value);
      packR.forEach(function (r) {
        var v = find(s, r.value); if (!v) return;
        var pp = form.querySelector('[data-pp="' + r.value + '"]'), ps = form.querySelector('[data-ps="' + r.value + '"]');
        if (pp) pp.textContent = fmt(v.price);
        if (ps && one) ps.textContent = 'Save ' + fmt(one.price * (+r.dataset.n) - v.price);
        r.disabled = !v.ok;
      });
      var cur = find(s, val(packR)); if (!cur) return;
      if (vidEl) vidEl.value = cur.id;
      if (buyBtn) buyBtn.disabled = !cur.ok;
      live(cur.price);
      return;
    }
    var c = idR.filter(function (r) { return r.checked; })[0]; if (c) live(+c.dataset.price);
  };
  sizeR.concat(packR, idR).forEach(function (r) { r.addEventListener('change', packUpd); });
  if (sizeR.length || idR.length) packUpd();
  // teklif kartlari (urun sayfasi): boyu ve paketi secer, satin alma kutusuna kaydirir
  d.querySelectorAll('[data-pick]').forEach(function (b) {
    b.addEventListener('click', function (ev) {
      var parts = b.dataset.pick.split('|');
      var rs = sizeR.filter(function (x) { return x.value === parts[0]; })[0], rp = packR.filter(function (x) { return x.value === parts[1]; })[0];
      if (!rs || !rp) return;
      ev.preventDefault(); rs.checked = true; rp.checked = true; packUpd();
      var buy = d.getElementById('buy'); if (buy) buy.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
    });
  });

  // sepete ekle: ayni form, return_to /cart olur
  var addc = d.querySelector('[data-addcart]'), ret = d.getElementById('cm-return');
  if (addc && ret) addc.addEventListener('click', function () {
    var f = addc.closest('form'); ret.value = R + 'cart'; if (f.requestSubmit) f.requestSubmit(); else f.submit();
  });

  // sabit satin alma cubugu: ana dugme ekrandan yukari cikinca gorunur; urun sayfasinda formu gonderir
  var sbar = d.querySelector('[data-sbar]'), anchor = d.querySelector('[data-sbar-anchor]');
  if (sbar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      en.forEach(function (x) { var on = !x.isIntersecting && x.boundingClientRect.top < 0; sbar.classList.toggle('is-on', on); d.body.classList.toggle('sbar-on', on); });
    }).observe(anchor);
    var sb = sbar.querySelector('[data-sbar-buy]');
    if (sb && form) sb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
  }

  // sepet sayfasi: adet dugmeleri formu gonderir
  var cartf = d.querySelector('[data-cart]');
  if (cartf) {
    var live = !!cartf.getAttribute('action');
    var send = function () { if (live) { if (cartf.requestSubmit) cartf.requestSubmit(); else cartf.submit(); } };
    cartf.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () { var inp = b.parentNode.querySelector('input'); inp.value = Math.max(0, (+inp.value || 0) + (+b.dataset.q)); send(); });
    });
    cartf.querySelectorAll('input[name="updates[]"]').forEach(function (i) { i.addEventListener('change', send); });
  }

  // teslim cizelgesi: cikis is gunuyle (hafta sonu sayilmaz), yol takvim gunuyle (site.py SHIP_DAYS). Noel son siparis tarihi gecince not degisir.
  var eta = d.querySelector('[data-eta]');
  if (eta) {
    var hd = eta.dataset.h.split(',').map(Number), td = eta.dataset.t.split(',').map(Number);
    var addB = function (from, n) { var x = new Date(from.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
    var addD = function (from, n) { var x = new Date(from.getTime()); x.setDate(x.getDate() + n); return x; };
    var day = function (x) { return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var now = new Date();
    eta.querySelector('[data-eta-0]').textContent = day(now);
    eta.querySelector('[data-eta-1]').textContent = 'By ' + day(addB(now, hd[1]));
    eta.querySelector('[data-eta-2]').textContent = day(addD(addB(now, hd[0]), td[0])) + ' to ' + day(addD(addB(now, hd[1]), td[1]));
    var last = new Date(eta.dataset.last + 'T23:59:59'), xmas = new Date(last.getFullYear(), 11, 25, 23, 59), note = eta.querySelector('[data-eta-note]');
    if (note && now > last) {
      if (now <= xmas) { note.textContent = note.dataset.late; note.className = 'eta__note is-late'; } else note.hidden = true;
    }
  }

  // kargo takibi: 17TRACK'te numarayla acilir
  var tf = d.querySelector('[data-track]');
  if (tf) tf.addEventListener('submit', function (ev) {
    var v = (tf.querySelector('input').value || '').trim(); if (!v) return;
    ev.preventDefault(); window.open('https://t.17track.net/en#nums=' + encodeURIComponent(v), '_blank', 'noopener');
  });

  // mobil menu: header sigmazsa uc cizgiye gecer; linke tiklayinca ve Esc ile kapanir
  var hdr = d.querySelector('.hdr'), burger = d.querySelector('[data-menu]'), hin = d.querySelector('.hdr__in');
  if (hdr && hin) {
    var hnav = hdr.querySelector('.nav'), htop = hdr.querySelector('.hdr__top');
    var fit = function () { hdr.classList.remove('is-compact'); if ((hnav && hnav.scrollWidth > hnav.clientWidth + 1) || (htop && htop.scrollWidth > htop.clientWidth + 1) || window.innerWidth < 860) hdr.classList.add('is-compact'); };
    fit(); window.addEventListener('resize', fit);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(fit);
  }
  if (hdr && burger) {
    var setMenu = function (on) { hdr.classList.toggle('is-open', on); burger.setAttribute('aria-expanded', on ? 'true' : 'false'); };
    burger.addEventListener('click', function () { setMenu(!hdr.classList.contains('is-open')); });
    hdr.querySelectorAll('.nav a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
    d.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') setMenu(false); });
    d.addEventListener('click', function (ev) { if (hdr.classList.contains('is-open') && !hdr.contains(ev.target)) setMenu(false); });
  }
  // ana sayfa bolum linkleri (/#look): bolum bu sayfada da varsa (urun sayfasi) sayfa degistirmeden oraya kayar
  d.querySelectorAll('a[href*="#"]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
      if (!u.hash || u.search || !(u.pathname === '/' || /index\.html$/.test(u.pathname) || u.pathname === location.pathname)) return;
      var t = d.getElementById(u.hash.slice(1)); if (!t) return;
      ev.preventDefault(); t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', u.hash);
    });
  });

  // politika metni: Shopify editorunun bos paragraflari bosluk birakmasin
  d.querySelectorAll('.polp .rte p').forEach(function (p) { if (!p.textContent.trim() && !p.querySelector('img,iframe,table')) p.remove(); });

  // para birimi secici: secince localization formu gonderilir
  d.querySelectorAll('[data-loc]').forEach(function (s) {
    s.addEventListener('change', function () { if (s.form && s.form.getAttribute('action') !== '#') s.form.submit(); });
  });

  // en uste don: 600px asagi inince gorunur, WhatsApp butonunun ustunde durur
  var tt = d.querySelector('[data-totop]');
  if (tt) {
    var ttUpd = function () { tt.classList.toggle('is-on', window.scrollY > 600); };
    window.addEventListener('scroll', ttUpd, { passive: true }); ttUpd();
    tt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' }); });
  }

  // ---------------------------------------------------------------- ilk karede yalniz LED'ler oynar
  // (patron 2026-10-19: "ilk gorseli hareketli yap, hareketli olan sey led olacak sadece"). Fotograf ayni kalir; ustune ekran
  // karisimli (screen) canvas: sonuk arka plan boncuklarinda kar yagar, kardan adam goz kirpar. Izgara scripts/led_anim_grid.py'den.
  // Kare ondeyken ve ekrandayken calisir, sekme gizliyken durur, hareket azaltma tercihinde hic baslamaz.
  var lai = d.querySelector('[data-led-anim]'), laj = d.getElementById('cm-led-anim'), LA = null;
  try { LA = laj && JSON.parse(laj.textContent); } catch (x) {}
  if (lai && LA && main && !RM) (function () {
    var cvs = d.createElement('canvas'), g = cvs.getContext('2d'), Wd = 0, spr = null, raf = 0, seen = false, lastT = 0;
    if (!g) return;
    cvs.className = 'gal__led'; cvs.setAttribute('aria-hidden', 'true'); main.insertBefore(cvs, lai.nextSibling);
    var C = LA.cells, NC = LA.cols, NR = LA.rows, lvl = C.map(function () { return 0; });
    var fl = [], blinkAt = 1800, blinkEnd = 0;
    for (var i = 0; i < NC * 2; i++) fl.push({ c: i % NC, y: i < NC && Math.random() < 0.5 ? Math.random() * NR : -1, v: 1 / (110 + Math.random() * 70), wait: Math.random() * 3200 });
    var mk = function () {          // yanan beyaz LED: dolu beyaz cekirdek + soguk hale (fotograftaki kardan adam noktalari gibi)
      var c = d.createElement('canvas'), s = Math.max(8, Math.ceil(LA.r * 2 * Wd / 10000)), m = s / 2, x = c.getContext('2d');
      c.width = c.height = s;
      var gr = x.createRadialGradient(m, m, 0, m, m, m);
      gr.addColorStop(0, 'rgba(255,255,255,1)'); gr.addColorStop(0.4, 'rgba(255,255,255,1)'); gr.addColorStop(0.52, 'rgba(232,240,255,.72)');
      gr.addColorStop(0.7, 'rgba(190,212,245,.26)'); gr.addColorStop(1, 'rgba(170,200,240,0)');
      x.fillStyle = gr; x.fillRect(0, 0, s, s); return c;
    };
    var size = function () {
      var r = Math.min(2, window.devicePixelRatio || 1), w = Math.round(main.clientWidth * r);
      if (!w || w === Wd) return;
      Wd = cvs.width = cvs.height = w; spr = mk();
    };
    var live = function () { return seen && !d.hidden && lai.classList.contains('is-on'); };
    var loop = function (t) {
      raf = 0; if (!live()) { lastT = 0; return; }
      var dt = lastT ? Math.min(60, t - lastT) : 16, fade = Math.exp(-dt / 150); lastT = t;
      for (var k = 0; k < lvl.length; k++) lvl[k] *= fade;
      for (var i = 0; i < fl.length; i++) {   // her dizide iki kar tanesi asagi iner, LED LED atlayarak
        var f = fl[i];
        if (f.y < 0) { f.wait -= dt; if (f.wait <= 0) { f.y = 0; f.v = 1 / (110 + Math.random() * 70); } continue; }
        f.y += f.v * dt;
        if (f.y >= NR) { f.y = -1; f.wait = 300 + Math.random() * 3200; continue; }
        var c = (f.y | 0) * NC + f.c;
        if (C[c][2] === 'b') lvl[c] = 1;
      }
      blinkAt -= dt;
      if (blinkAt <= 0) { blinkEnd = 170; blinkAt = 2600 + Math.random() * 2600; }
      if (blinkEnd > 0) { blinkEnd -= dt; C.forEach(function (c, k) { if (c[2] === 'e') lvl[k] = 1; }); }
      g.clearRect(0, 0, Wd, Wd);
      var s = spr.width, q = Wd / 10000;
      for (var k2 = 0; k2 < C.length; k2++) {
        if (lvl[k2] < 0.02) continue;
        g.globalAlpha = Math.min(1, lvl[k2]); g.drawImage(spr, C[k2][0] * q - s / 2, C[k2][1] * q - s / 2);
      }
      g.globalAlpha = 1;
      raf = window.requestAnimationFrame(loop);
    };
    var kick = function () { size(); if (!raf && live()) raf = window.requestAnimationFrame(loop); };
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { seen = en[0].isIntersecting; kick(); }).observe(main);
    else seen = true;
    if ('MutationObserver' in window) new MutationObserver(kick).observe(lai, { attributes: true, attributeFilter: ['class'] });
    d.addEventListener('visibilitychange', kick);
    window.addEventListener('resize', function () { kick(); });
    kick();
  })();

  // ---------------------------------------------------------------- canli LED onizleme
  // Perde gercek cozunurlukte (20 x 20) cizilir: her nokta bir LED, aralari karanlik. Desenler led.py ile ayni (#cm-led).
  // Acilista desenler sirayla doner (hareket azaltma acikken donmez); ziyaretci secince ya da yazinca durur.
  var cv = d.querySelector('[data-try-cv]'), ldj = d.getElementById('cm-led'), LD = null;
  try { LD = ldj && JSON.parse(ldj.textContent); } catch (x) {}
  if (cv && LD && cv.getContext) (function () {
    var N = LD.grid, ctx = cv.getContext('2d'), W = 600, pad = 0, cell = 0, glow = {};
    var FONT = {
      A: '01110,10001,10001,11111,10001,10001,10001', B: '11110,10001,10001,11110,10001,10001,11110', C: '01111,10000,10000,10000,10000,10000,01111',
      D: '11110,10001,10001,10001,10001,10001,11110', E: '11111,10000,10000,11110,10000,10000,11111', F: '11111,10000,10000,11110,10000,10000,10000',
      G: '01111,10000,10000,10011,10001,10001,01111', H: '10001,10001,10001,11111,10001,10001,10001', I: '111,010,010,010,010,010,111',
      J: '00111,00010,00010,00010,00010,10010,01100', K: '10001,10010,10100,11000,10100,10010,10001', L: '10000,10000,10000,10000,10000,10000,11111',
      M: '10001,11011,10101,10101,10001,10001,10001', N: '10001,11001,11001,10101,10011,10011,10001', O: '01110,10001,10001,10001,10001,10001,01110',
      P: '11110,10001,10001,11110,10000,10000,10000', Q: '01110,10001,10001,10001,10101,10010,01101', R: '11110,10001,10001,11110,10100,10010,10001',
      S: '01111,10000,10000,01110,00001,00001,11110', T: '11111,00100,00100,00100,00100,00100,00100', U: '10001,10001,10001,10001,10001,10001,01110',
      V: '10001,10001,10001,10001,10001,01010,00100', W: '10001,10001,10001,10101,10101,10101,01010', X: '10001,10001,01010,00100,01010,10001,10001',
      Y: '10001,10001,01010,00100,00100,00100,00100', Z: '11111,00001,00010,00100,01000,10000,11111',
      0: '01110,10001,10011,10101,11001,10001,01110', 1: '010,110,010,010,010,010,111', 2: '01110,10001,00001,00010,00100,01000,11111',
      3: '11110,00001,00001,01110,00001,00001,11110', 4: '00010,00110,01010,10010,11111,00010,00010', 5: '11111,10000,11110,00001,00001,10001,01110',
      6: '00110,01000,10000,11110,10001,10001,01110', 7: '11111,00001,00010,00100,01000,01000,01000', 8: '01110,10001,10001,01110,10001,10001,01110',
      9: '01110,10001,10001,01111,00001,00010,01100', '!': '1,1,1,1,1,0,1', '?': '01110,10001,00001,00010,00100,00000,00100',
      '.': '0,0,0,0,0,0,1', ',': '00,00,00,00,00,01,10', "'": '1,1,0,0,0,0,0', '-': '000,000,000,111,000,000,000',
      '&': '01100,10010,10100,01000,10101,10010,01101', '+': '000,010,010,111,010,010,000', ' ': '000,000,000,000,000,000,000'
    };
    var hexRgb = function (h) { return [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)]; };
    var size = function () {
      var r = Math.min(2, window.devicePixelRatio || 1), w = Math.max(240, Math.round((cv.clientWidth || 600) * r));
      if (w === W && cv.width === w) return;
      W = cv.width = cv.height = w; pad = W * 0.035; cell = (W - 2 * pad) / N; glow = {};
    };
    var dot = function (hex) {      // renk basina bir kez: renkli hale + parlak cekirdek (beyaza yakin merkez)
      if (glow[hex]) return glow[hex];
      var c = d.createElement('canvas'), s = Math.ceil(cell * 1.9), g = c.getContext('2d'), m = s / 2, rgb = hexRgb(hex);
      c.width = c.height = s;
      var rg = 'rgba(' + rgb.join(',') + ',';
      var gr = g.createRadialGradient(m, m, 0, m, m, m);
      gr.addColorStop(0, rg + '.55)'); gr.addColorStop(0.3, rg + '.22)'); gr.addColorStop(1, rg + '0)');
      g.fillStyle = gr; g.fillRect(0, 0, s, s);
      g.beginPath(); g.arc(m, m, cell * 0.2, 0, 7); g.fillStyle = hex; g.fill();
      g.beginPath(); g.arc(m, m, cell * 0.1, 0, 7);
      g.fillStyle = 'rgb(' + rgb.map(function (v) { return Math.round(v + (255 - v) * 0.65); }).join(',') + ')'; g.fill();
      return (glow[hex] = c);
    };
    var draw = function (fr) {      // fr: N*N dizi, her biri null ya da [hex, parlaklik]
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      ctx.fillStyle = '#04110B'; ctx.fillRect(0, 0, W, W);
      ctx.strokeStyle = 'rgba(255,255,255,.06)'; ctx.lineWidth = Math.max(1, cell * 0.04);
      for (var x = 0; x < N; x++) { var lx = pad + cell * (x + 0.5); ctx.beginPath(); ctx.moveTo(lx, 0); ctx.lineTo(lx, W); ctx.stroke(); }
      ctx.fillStyle = '#17271F';
      for (var i = 0; i < N * N; i++) if (!fr[i]) { ctx.beginPath(); ctx.arc(pad + cell * (i % N + 0.5), pad + cell * (Math.floor(i / N) + 0.5), cell * 0.13, 0, 7); ctx.fill(); }
      ctx.globalCompositeOperation = 'lighter';
      for (var j = 0; j < N * N; j++) {
        var f = fr[j]; if (!f) continue;
        var im = dot(f[0]); ctx.globalAlpha = f[1];
        ctx.drawImage(im, pad + cell * (j % N + 0.5) - im.width / 2, pad + cell * (Math.floor(j / N) + 0.5) - im.height / 2);
      }
      ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
    };
    var phase = []; for (var p = 0; p < N * N; p++) phase.push(Math.random() * 6.28);
    var mode = 'sprite', name = 'santa', since = 0, text = '', tcol = 'R', cols = [], off = 0, flakes = [], auto = !RM, autoAt = 0, autoI = 0, visible = false;
    var ORDER = Object.keys(LD.s).concat(['snow', 'text']);
    var tabs = [].slice.call(d.querySelectorAll('[data-try]')), colBtns = [].slice.call(d.querySelectorAll('[data-col]'));
    var press = function (k) { tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.dataset.try === k ? 'true' : 'false'); }); };
    var setSprite = function (k, now) {
      name = k; mode = k === 'snow' ? 'snow' : 'sprite'; since = now || performance.now(); press(k);
      if (mode === 'snow') { flakes = []; for (var i = 0; i < 26; i++) flakes.push([Math.floor(Math.random() * N), Math.random() * N, 0.06 + Math.random() * 0.08]); }
    };
    var buildText = function (s) {
      cols = []; var hex = LD.pal[tcol];
      for (var k = 0; k < N; k++) cols.push(null);
      s.toUpperCase().split('').forEach(function (ch) {
        var g = FONT[ch]; if (!g) return; var rows = g.split(','), w = rows[0].length;
        for (var x = 0; x < w; x++) cols.push(rows.map(function (r) { return r[x] === '1' ? hex : null; }));
        cols.push(null);
      });
      for (var j = 0; j < 6; j++) cols.push(null);
    };
    var setText = function (s) { text = s; mode = 'text'; off = 0; buildText(s); press(''); };
    var frame = function (now) {
      var fr = new Array(N * N), i, t = now / 1000;
      if (mode === 'sprite') {
        var sp = LD.s[name], rows = Math.min(N, Math.floor((now - since) / 22) + 1);   // yeni desen satir satir yanar
        for (i = 0; i < N * N; i++) {
          var ch = sp[i]; if (ch === '.' || Math.floor(i / N) >= rows) continue;
          fr[i] = [LD.pal[ch], RM ? 1 : 0.86 + 0.14 * Math.sin(t * 2.2 + phase[i])];
        }
      } else if (mode === 'snow') {
        for (var x = 0; x < N; x++) { fr[(N - 1) * N + x] = [LD.pal.W, 0.9]; if ((x * 7) % 5 < 3) fr[(N - 2) * N + x] = [LD.pal.W, 0.75]; }
        flakes.forEach(function (f) {
          if (!RM) { f[1] += f[2]; if (f[1] >= N - 2) { f[1] = 0; f[0] = Math.floor(Math.random() * N); } }
          var y = Math.floor(f[1]); if (y < N - 2) fr[y * N + f[0]] = [f[0] % 3 ? LD.pal.W : LD.pal.C, 0.95];
        });
      } else {
        var top = Math.floor((N - 7) / 2), start = Math.floor(off);
        for (var cx = 0; cx < N; cx++) {
          var c = cols[(start + cx) % cols.length]; if (!c) continue;
          for (var r = 0; r < 7; r++) if (c[r]) fr[(top + r) * N + cx] = [c[r], 1];
        }
      }
      return fr;
    };
    var last = 0, raf = 0;
    var loop = function (now) {
      raf = 0;
      if (!visible || d.hidden) return;
      size();
      if (mode === 'text' && last) off += (now - last) / 85;                  // yaklasik 12 sutun/sn, gercek perde hizi
      if (off >= cols.length) off -= cols.length;
      if (auto && now - autoAt > (mode === 'text' ? 9000 : 2600)) {            // acilis turu: desenler, kar, sonra kayan yazi
        autoAt = now; autoI = (autoI + 1) % ORDER.length;
        if (ORDER[autoI] === 'text') setText('MERRY XMAS'); else setSprite(ORDER[autoI], now);
      }
      draw(frame(now)); last = now;
      if (RM && mode !== 'text') return;                                       // hareket azaltma: tek kare
      raf = window.requestAnimationFrame(loop);
    };
    var kick = function () { if (!raf) { last = 0; raf = window.requestAnimationFrame(loop); } };
    var stopAuto = function () { auto = false; };
    tabs.forEach(function (t) { t.addEventListener('click', function () { stopAuto(); setSprite(t.dataset.try); kick(); }); });
    colBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        tcol = b.dataset.col; colBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        stopAuto(); setText(text || (inp && inp.value) || 'MERRY XMAS'); kick();
      });
    });
    var tform = d.querySelector('[data-try-form]'), inp = d.querySelector('[data-try-in]');
    if (tform) tform.addEventListener('submit', function (ev) { ev.preventDefault(); stopAuto(); setText((inp.value || '').trim() || 'MERRY XMAS'); kick(); });
    if (inp) inp.addEventListener('input', function () { var v = inp.value.trim(); if (v) { stopAuto(); setText(v); kick(); } });
    setSprite('santa', 0); autoAt = performance.now();
    size(); draw(frame(autoAt));                                               // ilk kare hemen (rAF gecikse de bos kalmaz)
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { en.forEach(function (x) { visible = x.isIntersecting; if (visible) kick(); }); }, { rootMargin: '120px' }).observe(cv);
    } else { visible = true; kick(); }
    d.addEventListener('visibilitychange', function () { if (!d.hidden) kick(); });
    window.addEventListener('resize', function () { kick(); });
  })();

  // ---------------------------------------------------------------- kar (patron 2026-10-19: "kar da yagsin sitede")
  // Hafif: tek canvas, en fazla 90 tane, sekme gizliyken durur. Hareket azaltma tercihinde kapali. Header'daki dugmeyle kapanir (hatirlanir).
  var snowBtn = d.querySelector('[data-snowbtn]');
  (function () {
    var on = !RM, pref = null;
    try { pref = localStorage.getItem('cm-snow'); } catch (x) {}
    if (pref === '0') on = false; else if (pref === '1') on = true;
    var cvs = null, sx = null, fl = [], Wd = 0, Ht = 0, dpr = 1, raf = 0, lastT = 0, sprite = null;
    var mk = function () {          // beyaz cekirdek + acik mavi govde: beyaz zeminde halka degil tane gibi gorunur
      var c = d.createElement('canvas'), s = 16, g = c.getContext('2d'); c.width = c.height = s;
      var gr = g.createRadialGradient(8, 8, 0, 8, 8, 8);
      gr.addColorStop(0, 'rgba(255,255,255,1)'); gr.addColorStop(0.3, 'rgba(240,247,252,1)'); gr.addColorStop(0.62, 'rgba(196,214,228,.9)'); gr.addColorStop(1, 'rgba(170,192,210,0)');
      g.fillStyle = gr; g.fillRect(0, 0, s, s); return c;
    };
    var seed = function (anyY) {
      return { x: Math.random() * Wd, y: anyY ? Math.random() * Ht : -10, r: 1 + Math.random() * 2.6, v: 0, a: 0.45 + Math.random() * 0.5, p: Math.random() * 6.28, w: 0.4 + Math.random() * 0.9 };
    };
    var resize = function () {
      dpr = Math.min(1.5, window.devicePixelRatio || 1); Wd = window.innerWidth; Ht = window.innerHeight;
      cvs.width = Math.round(Wd * dpr); cvs.height = Math.round(Ht * dpr); sx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(90, Math.max(28, Wd / 16)));
      while (fl.length < n) fl.push(seed(true)); fl.length = n;
    };
    var tick = function (t) {
      raf = 0; if (!on || d.hidden) return;
      var dt = lastT ? Math.min(50, t - lastT) : 16; lastT = t;
      sx.clearRect(0, 0, Wd, Ht);
      for (var i = 0; i < fl.length; i++) {
        var f = fl[i];
        f.y += (0.35 + f.r * 0.32) * dt / 16;
        f.x += Math.sin(t / 1000 * f.w + f.p) * 0.35 * dt / 16;
        if (f.y > Ht + 10 || f.x < -20 || f.x > Wd + 20) { fl[i] = seed(false); continue; }
        var s = f.r * 2.4; sx.globalAlpha = f.a; sx.drawImage(sprite, f.x - s / 2, f.y - s / 2, s, s);
      }
      raf = window.requestAnimationFrame(tick);
    };
    var start = function () {
      if (!cvs) {
        cvs = d.createElement('canvas'); cvs.className = 'snow'; cvs.setAttribute('aria-hidden', 'true');
        sx = cvs.getContext('2d'); sprite = mk(); d.body.appendChild(cvs); resize();
        window.addEventListener('resize', function () { if (cvs) resize(); });
      }
      cvs.hidden = false; lastT = 0; if (!raf) raf = window.requestAnimationFrame(tick);
    };
    var stop = function () { if (raf) window.cancelAnimationFrame(raf); raf = 0; if (cvs) { sx.clearRect(0, 0, Wd, Ht); cvs.hidden = true; } };
    var set = function (v) { on = v; if (snowBtn) snowBtn.setAttribute('aria-pressed', v ? 'true' : 'false'); if (v) start(); else stop(); };
    if (snowBtn) snowBtn.addEventListener('click', function () { set(!on); try { localStorage.setItem('cm-snow', on ? '1' : '0'); } catch (x) {} });
    d.addEventListener('visibilitychange', function () { if (on && !d.hidden) start(); });
    set(on);
  })();

  // reveal
  var els = d.querySelectorAll('.rv');
  if (!('IntersectionObserver' in window)) { els.forEach(function (x) { x.classList.add('in'); }); return; }
  var io = new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (x) { io.observe(x); });
})();
